import { ActionType } from "../action_types/index"

export type SnackbarAction = { type: ActionType.SNACKBAR_TYPE; payload: [] };


export const showSnackbar = (show: any): SnackbarAction => ({
  type: ActionType.SNACKBAR_TYPE,
  payload: show,
});



/* interface showSnackbar {
  type: ActionType.SNACKBAR_TYPE,
  payload: [],
}
 */


/* export type Action = showSnackbar; */